export const TAB_IDS = {
  MANAGE: "manage",
  SETTINGS: "settings",
  //
  QUESTIONS: "questions",
  EMAILS: "emails",
  ASSIGN: "assign"
};
